/* @flow */
// / typecheck: ignore file
import React from 'react';

import './styles/BadgedBox.scss';

type Props = {
  text: string,
  children?: any,
};

export default function BadgedBox(props: Props) {
  return (
    <div className="BadgedBox">
      <div className="BadgedBox-badge">{props.text}</div>
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/BadgedBox.jsx